<div class="footer-wrapper">
  <!-- Mobile alerts -->
  @for (alert of mobileAlerts; track $index) {
    <ut-alert
      class="visible-xs"
      [type]="alert.type"
      [dismissible]="true"
      (closed)="closeAlert($index)">
      <span [innerHTML]="alert.msg"></span>
    </ut-alert>
  }

  <div class="container-fluid">
    <h2>Pending Articles</h2>

    <!-- Custom tabs component -->
    <ut-tabs [activeTabId]="activeTab" (tabChange)="onTabChange($event)">
      <!-- Pending tab -->
      <ut-tab tabId="pending" label="Pending">
        @for (article of pendingArticles?.feedItems ?? []; track article.id) {
          <div class="feed article pending-article">
            <div class="feed-header-info-name">
              <a uiSref="profile.about" [uiParams]="{profileId: article.user.slug}">
                <ut-avatar-badges [user]="article.user"></ut-avatar-badges>
              </a>
              <div class="feed-item-info">
                <a uiSref="profile.about" [uiParams]="{profileId: article.user.slug}">{{ article.user.name | strLimit: 20 }}</a>
                <ut-dynamic-tooltip [user]="article.user" tooltipType="user">
                  <div
                    tabindex="0"
                    class="fa fa-info-circle"
                    role="button"
                    [attr.aria-label]="'Open ' + article.user.name + ' tooltip'">
                  </div>
                </ut-dynamic-tooltip>
                @if (article.user.user_title) {
                  <div class="feed-item-header-title">
                    {{ article.user.user_title | strLimit: 50 }}
                  </div>
                }
                <span class="time-stamp">{{ article.updated_at | relativeDate }}</span>
              </div>
            </div>

            <div class="pending-article-title">
              <h4>
                <a uiSref="singlearticle" [uiParams]="{articleId: article.slug}" [innerHTML]="article.title | emojiHtml"></a>
              </h4>
            </div>

            <div class="pending-article-content">
              @if (article.content) {
                <p class="feed-item-description" [innerHTML]="article.content | ulinky"></p>
              }
            </div>

            <div class="func-btns">
              <div class="main-btns">
                @if (article.current_user_permissions?.publish) {
                  <button
                    class="action-btn action-btn--primary"
                    type="button"
                    (click)="confirmPublish(article, 'publish')">
                    Publish
                  </button>
                }
                @if (article.current_user_permissions?.reject) {
                  <button
                    class="action-btn"
                    type="button"
                    (click)="confirmReject(article)">
                    Reject
                  </button>
                }
              </div>
            </div>
          </div>
        }

        <ut-load-more
          (loadMore)="pendingArticles.loadMore()"
          [isLoading]="pendingArticles.isLoading"
          [isLastPage]="pendingArticles.isLastPage">
        </ut-load-more>
      </ut-tab>

      <!-- Rejected tab -->
      <ut-tab tabId="rejected" label="Rejected">
        @for (article of rejectedArticles?.feedItems ?? []; track article.id) {
          <div class="feed article pending-article">
            <div style="display: flex" class="feed-header-info-name">
              <a uiSref="profile.about" [uiParams]="{profileId: article.user.slug}">
                <ut-avatar-badges [user]="article.user"></ut-avatar-badges>
              </a>
              <div class="feed-item-info">
                <a uiSref="profile.about" [uiParams]="{profileId: article.user.slug}">{{ article.user.name | strLimit: 20 }}</a>
                <ut-dynamic-tooltip [user]="article.user" tooltipType="user">
                  <div
                    tabindex="0"
                    class="fa fa-info-circle"
                    role="button"
                    [attr.aria-label]="'Open ' + article.user.name + ' tooltip'">
                  </div>
                </ut-dynamic-tooltip>
                @if (article.user.user_title) {
                  <div class="feed-item-header-title">
                    {{ article.user.user_title | strLimit: 50 }}
                  </div>
                }
                <span class="time-stamp">{{ article.updated_at | relativeDate }}</span>
              </div>
            </div>

            <div class="pending-article-content">
              <h4>
                <a uiSref="singlearticle" [uiParams]="{articleId: article.slug}" [innerHTML]="article.title | emojiHtml"></a>
              </h4>
            </div>

            <div class="pending-article-content">
              @if (article.content) {
                <p class="feed-item-description" [innerHTML]="article.content | ulinky"></p>
              }
              <strong>Reason:</strong> {{ article.reject_reason }}
              <br />
              <strong>Reviewer:</strong> {{ article.reviewer?.name }}
            </div>

            <div class="func-btns">
              <div class="main-btns">
                @if (currentUser?.user_type === 'admin') {
                  <button
                    class="action-btn action-btn--primary"
                    type="button"
                    (click)="confirmPublish(article, 'reject')">
                    Publish
                  </button>
                }
              </div>
            </div>
          </div>
        }

        <ut-load-more
          (loadMore)="rejectedArticles.loadMore()"
          [isLoading]="rejectedArticles.isLoading"
          [isLastPage]="rejectedArticles.isLastPage">
        </ut-load-more>
      </ut-tab>
    </ut-tabs>
  </div>
</div>
